<template>
    <div class="ufo--about-header">
        <div class="grid">
            <div class="about-title">
                <div class="about-title-container">
                    <AnimationWrapper v-if="animated">
                        <template #animationContent>
                            <h1 class="title">{{ titleText }}</h1>
                        </template>
                    </AnimationWrapper>
                    <h1 v-else class="title">{{ titleText }}</h1>
                </div>
            </div>
            <AnimationWrapper v-if="animated">
                <template #animationContent>
                    <div class="back" @click="$emit('back')">⟵ Back</div>
                </template>
            </AnimationWrapper>
            <div v-else class="back" @click="$emit('back')">⟵ Back</div>
        </div>
    </div>
</template>

<script>
import AnimationWrapper from "@/scripts/common/components/AnimationWrapper.vue";

export default {
    name: "PageHeader",
    components: { AnimationWrapper },
    props: {
        title: {
            type: String,
            default: "",
        },
        animated: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        titleText() {
            return this.title || "";
        },
    },
};
</script>
